import React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-switch-lang';
import { Password } from '../../../constant';
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import authStorage from '../../../storages/mobx/authStorage';

function PasswordField({ t }) {
  return (
    <div className="form-group">
      <label
        htmlFor="auth-password-field"
        className="col-form-label"
      >
        {t('auth.Password')}
      </label>
      <input
        id="auth-password-field"
        className="form-control"
        type="password"
        name="password"
        value={authStorage.enteredPassword}
        onChange={(e) => authStorage.changeField('enteredPassword', e.target.value)}
      />

    </div>
  );
}

PasswordField.propTypes = {};

export default translate(observer(PasswordField));
